<template>
    <div>
         <div class="shipping-services" @click="$emit('selected', costType)">
          <div class="align-items-stretch">
            <div class="shipping-service cursor-pointer h-100" :class="{ 'selected' : costType == currentSelected}">
              <p class="service-name">{{ costType }}</p>
              
              <p class="service-price">&#8358;{{ total }}</p>
              
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    export default {
        props : {
            shippingService : Object,
            costDetails : Object,
            costType : String,
            total : String,
            currentSelected : String || Number
        }
    }
</script>

<style lang="scss" scoped>
.shipping-services {
  padding: 1.5rem 0rem;
  width: 100%;
}

.shipping-service {
  background: var(--lightblue);
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  text-align: center;
  color: var(--primaryblue);
  padding: 1.5rem 0;
  margin-bottom: 1.5rem;
  transition: 0.5s ease-in-out;
  width: 220px;

  &.selected {
    background:var(--primaryblue);
    color: white
  }
}

.shipping-service:hover {
  transform: scale(1.05);
}

.service-name {
  opacity: 0.8;
  font-size: 1.1rem;
}

.service-price {
  font-weight: 500;
  font-size: 1.5rem;
  padding: 0.5rem 0 0.75rem;
}

.service-schedule {
  font-size: 0.8rem;
  padding: 1rem 0 0.8rem;
}

</style>